import { CustomField } from '../../types';

// Mirrors the backend's rules (services/workflow/customFields.ts): first
// occurrence of a key wins, invalid keys are skipped.
const KEY = /^[A-Za-z_][A-Za-z0-9_.-]*$/;
const UNSAFE_KEYS = new Set(['__proto__', 'constructor', 'prototype']);

/**
 * Custom field values as this browser sees them: each default, replaced by the
 * form URL's `?<key>=` value when that field opted in and the URL carries it.
 * (The visitor's own answer is applied later, on the server.)
 */
export const resolveCustomValues = (
  fields: CustomField[] | undefined,
  search: string,
): Record<string, string> => {
  const query = new URLSearchParams(search);
  const resolved = new Map<string, string>();
  for (const row of fields || []) {
    const key = (row.key || '').trim();
    if (!KEY.test(key) || UNSAFE_KEYS.has(key) || resolved.has(key)) continue;
    const fromUrl = row.fromQuery ? query.get(key) : null;
    resolved.set(key, fromUrl && fromUrl.trim() !== '' ? fromUrl : row.value || '');
  }
  return Object.fromEntries(resolved);
};
